<template>
  <BaseDetailLayout :title="`Storage Type`" :isBackBtnVisible="false">
    <template #action>
      <PrimaryButton
        id="storageTypeAdd"
        color="primary"
        class="white--text"
        depressed
        :name="`Add ${configurationModule.storageType}`"
        icon="mdi-plus"
        iconSize="x-large"
        @click="addStorageType"
      >
      </PrimaryButton>
    </template>

    <template #detail>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-data-table
            class="custom-table"
            :headers="headers"
            :items="items"
            item-key="id"
            hide-default-footer
            hide-default-header
            disable-sort
            height="82vh"
            :items-per-page="-1"
          >
            <template v-slot:header="{ props: { headers } }">
              <th v-for="(head, keyIndex) in headers" :key="`head_${keyIndex}`">
                <div class="d-flex align-center my-4 text-subtitle-2">
                  <ColorPickerBox
                    class="mr-2"
                    :color_code="head.color_code"
                  ></ColorPickerBox>
                  {{ head.text }}
                  <span v-if="head.can_edit">
                    <v-icon @click="editStorageType(head.id)" small class="ml-2"
                      >mdi-pencil</v-icon
                    >
                  </span>
                </div>
              </th>
            </template>
            <template v-slot:item="{ item, index, headers }">
              <tr>
                <td
                  v-for="(head, keyIndex) in headers"
                  :key="`${index}${keyIndex}`"
                >
                  <template v-if="typeof item[head.value] === 'boolean'">
                    <v-icon :color="item[head.value] ? 'success' : 'error'">
                      {{
                        item[head.value]
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </template>
                  <template v-else>
                    <div class="d-flex align-center">
                      <ColorPickerBox
                        :color_code="item.color_code"
                      ></ColorPickerBox>
                      {{ item[head.value] }}
                    </div>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <template #dialog>
      <StorageTypeForm
        v-model="showStorageTypeForm"
        :itemID="selectedStorageTypeID"
        :editMode="isEditing"
        @refreshList="getStorageTypeMatrixData()"
      />
    </template>
  </BaseDetailLayout>
</template>

<script>
import { configurationModule } from "@/utils/moduleMapping";
import { bus } from "@/main";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";

import StorageTypeForm from "@/components/ModuleBasedComponents/StorageType/StorageTypeForm.vue";
import ColorPickerBox from "@/components/ModuleBasedComponents/StorageType/ColorPickerBox.vue";

export default {
  components: {
    BaseDetailLayout,
    StorageTypeForm,
    ColorPickerBox,
  },
  data() {
    return {
      isEditing: false,
      showStorageTypeForm: false,
      configurationModule,
      storageTypeList: [],
      items: [],
      initialHeaders: [
        {
          text: "",
          align: "start",
          value: "header",
        },
      ],
      headers: [],
      selectedStorageTypeID: null,
    };
  },
  computed: {
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getStorageTypeMatrixData(params = {}) {
      bus.$emit("showLoader", true);

      this.$api.storageType
        .getStorageTypeMatrix()
        .then((res) => {
          bus.$emit("showLoader", false);
          this.items = res.data.items;
          this.headers = this.initialHeaders.concat(
            ...res.data.headers.map((head) => {
              head.showEdit = true;
              return head;
            })
          );
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    addStorageType() {
      this.selectedStorageTypeID = null;
      this.isEditing = false;
      this.showStorageTypeForm = true;
    },
    editStorageType(id) {
      this.selectedStorageTypeID = id;
      this.isEditing = true;
      this.showStorageTypeForm = true;
    },
  },
  mounted() {
    this.getStorageTypeMatrixData();
  },
};
</script>
<style>
.custom-table .v-data-table__wrapper {
  border-collapse: separate;
}

.custom-table .v-data-table__wrapper tbody tr td {
  border-right: 1px solid #ccc;
}
</style>
